export const formTsAuctionBidFields = {
  UNIT_PRICE: 'unitPrice',
  AGREE_TO_AUTOMATIC_REPORT: 'agreeToAutomaticReport',
  AGREE_TO_MANUAL_REPORT: 'agreeToManualReport',
};
